import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoadMapComponent } from './road-map.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [RoadMapComponent],
  exports: [
    RoadMapComponent
  ]
})
export class RoadMapModule { }
